module.exports = __webpack_public_path__ + "media/images/flags/sc-72086f95e368232b42de1b0af45954ea.png";